import React from "react";
import { useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
import { Button } from "@src/components/Button";
import { Icon, type IconNameType } from "../Icon";

export interface EmptyStateProps {
  icon?: IconNameType;
  /** Title text */
  title: string;
  /** Description message */
  message?: string;
  /** Optional action button */
  action?: {
    label: string;
    onPress: () => void;
  };
}

/**
 * Empty state view.
 * Used when data loaded successfully but the result is empty (e.g., empty array).
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ icon = "folderOpen", title, message, action }) => {
  const { theme } = useUnistyles();

  return (
    <View flex={1} bg="background" justifyContent="center" alignItems="center" px="5xl" gap="lg">
      <Icon name={icon} size={theme.spacing["13xl"]} color={theme.colors.textMuted} />
      <Text textStyle="lg/semibold" textAlign="center">
        {title}
      </Text>
      {message && (
        <Text textStyle="md/regular" color="textMuted" textAlign="center">
          {message}
        </Text>
      )}
      {action && <Button label={action.label} variant="secondary" onPress={action.onPress} />}
    </View>
  );
};
